import React, { useCallback, useState } from "react";

import Announcement from "@mapmycustomers/shared/types/announcements/Announcement";

import getAnnouncementImageUrl from "@app/util/announcements/getAnnouncementImageUrl";
import loggingService from "@app/util/logging";

import styles from "./AnnouncementMedia.module.scss";

interface AnnouncementMediaProps {
  announcementId: Announcement["id"];
  contentType: Announcement["fileContentType"];
  url: Announcement["fileUrl"];
}

const AnnouncementMedia = ({ announcementId, contentType, url }: AnnouncementMediaProps) => {
  // Remember which URL failed rather than a bare flag: the modal reuses this component across
  // announcements, so a flag would suppress every later image too.
  const [failedUrl, setFailedUrl] = useState<string | undefined>();
  const imageUrl = getAnnouncementImageUrl({ fileContentType: contentType, fileUrl: url });
  const handleError = useCallback(() => {
    loggingService.error("Failed to load announcement image", { announcementId });
    setFailedUrl(imageUrl);
  }, [announcementId, imageUrl]);

  // No file, a non-image file, or an image that failed to load: the card renders with no media
  // area and no error.
  if (!imageUrl || failedUrl === imageUrl) {
    return null;
  }

  return (
    <div className={styles.container}>
      <img
        alt=""
        className={styles.image}
        onError={handleError}
        referrerPolicy="no-referrer"
        src={imageUrl}
      />
    </div>
  );
};

export default AnnouncementMedia;
